export const SERVICE_CATEGORIES = {
  EDUCATION: {
    id: 'education',
    label: 'Nauka języka, korepetycje, edukacja',
    subcategories: [
      { id: 'tasks', label: 'Zadania' },
      { id: 'tests', label: 'Testy' },
      { id: 'presentations', label: 'Prezentacje' },
      { id: 'video', label: 'Video' }
    ]
  },
  SPORT: {
    id: 'sport',
    label: 'Sport',
    subcategories: [
      { id: 'game_strategies', label: 'Schematy i strategia gry' },
      { id: 'video', label: 'Video' },
      { id: 'presentations', label: 'Prezentacje' }
    ]
  },
  PROGRAMMING: {
    id: 'programming',
    label: 'Programowanie, IT',
    subcategories: [
      { id: 'programs', label: 'Programy' },
      { id: 'websites', label: 'Strony internetowe' },
      { id: 'applications', label: 'Aplikacje' },
      { id: 'it_projects', label: 'Projekty IT' }
    ]
  },
  MULTIMEDIA: {
    id: 'multimedia',
    label: 'Fotografia, grafika, multimedia',
    subcategories: [
      { id: 'photos', label: 'Zdjęcia/reportaże' },
      { id: 'video', label: 'Video' },
      { id: 'presentations', label: 'Prezentacje' },
      { id: 'animations', label: 'Animacje' },
      { id: 'graphic_projects', label: 'Projekty graficzne' },
      { id: 'video_editing', label: 'Montaż filmów' },
      { id: '3d_projects', label: 'Projekty 3D' }
    ]
  },
  TEXTS: {
    id: 'texts',
    label: 'Teksty, tłumaczenia',
    subcategories: [
      { id: 'writing', label: 'Pisanie/redagowanie' },
      { id: 'translations', label: 'Tłumaczenia' },
      { id: 'proofreading', label: 'Korekta' },
      { id: 'linguistic_projects', label: 'Projekty lingwistyczne' }
    ]
  },
  MUSIC: {
    id: 'music',
    label: 'Muzyka',
    subcategories: [
      { id: 'singing_lessons', label: 'Lekcje śpiewu' },
      { id: 'instrument_lessons', label: 'Lekcje gry na instrumencie' },
      { id: 'music_creation', label: 'Tworzenie muzyki' },
      { id: 'recordings', label: 'Nagrania' }
    ]
  },
  OTHER: {
    id: 'other',
    label: 'Inne',
    subcategories: [
      { id: 'individual_project', label: 'Projekt indywidualny' }
    ]
  }
};

export const COPYRIGHT_TYPES = {
  LICENSE: {
    id: 'LICENSE',
    label: 'Licencja',
    description: 'Udzielasz praw majątkowych w ramach licencji. Otrzymasz wyższą wypłatę i nie musisz przygotowywać dokumentów!'
  },
  COPYRIGHT: {
    id: 'COPYRIGHT',
    label: 'Prawa autorskie',
    description: 'Przekazujesz na wyłączność prawa majątkowe. Otrzymasz wyższą wypłatę, ale musisz uzupełnić i przesłać protokół.'
  },
  NO_TRANSFER: {
    id: 'NO_TRANSFER',
    label: 'Brak przeniesienia praw autorskich',
    description: 'Bez dodatkowych formalności. Zachowasz prawa autorskie, a Twoja wypłata się nie zmieni.'
  }
};

export const CONTRACT_TEMPLATES = {
  education: {
    tasks: "preparing educational tasks",
    tests: "preparing tests and exams",
    presentations: "creating educational presentations",
    video: "creating educational video materials"
  },
  sport: {
    game_strategies: "developing game schemes and strategies",
    video: "creating sports video materials",
    presentations: "preparing sports presentations"
  },
  programming: {
    programs: "creating original computer program code",
    websites: "creating original website code",
    applications: "creating original application code",
    it_projects: "completing an IT project"
  },
  multimedia: {
    photos: "conducting a photo session/reportage",
    video: "creating video material",
    presentations: "preparing multimedia presentation",
    animations: "creating animations",
    graphic_projects: "completing a graphic design project",
    video_editing: "performing video editing",
    "3d_projects": "completing a 3D project"
  },
  texts: {
    writing: "writing/editing texts",
    translations: "performing translation",
    proofreading: "performing text proofreading",
    linguistic_projects: "completing a linguistic project"
  },
  music: {
    singing_lessons: "preparing materials for singing lessons",
    instrument_lessons: "preparing materials for instrument lessons", 
    music_creation: "creating a musical composition",
    recordings: "performing a music recording"
  },
  other: {
    individual_project: "completing an individual project"
  }
};

/**
 * Generate contract preview text based on category, subcategory, title, and description
 * @param category - Service category ID
 * @param subcategory - Service subcategory ID
 * @param title - Contract title
 * @param description - Contract description
 * @returns Generated contract text or null if template not found
 */
export function generateContractPreview(category, subcategory, title, description) {
  if (!category || !subcategory) {
    return null;
  }

  const template = CONTRACT_TEMPLATES[category]?.[subcategory];
  if (!template) {
    return null;
  }

  const baseText = `The Company entrusts, and the Contractor accepts to execute, a work consisting of ${template}`;
  const titleText = title ? ` "${title}"` : '';
  const descriptionText = description ? ` according to the project with functionalities: ${description}` : '';
  
  return `${baseText}${titleText}${descriptionText}.`;
}

export const FORM_STORAGE_KEY = 'one_time_contract_form_data';